export function withCvBuilderAnalyticsContext(
  analyticsContext?: UmamiEventData,
  properties?: UmamiEventData,
): UmamiEventData | undefined {
  if (!analyticsContext && !properties) {
    return undefined;
  }

  return {
    ...(analyticsContext ?? {}),
    ...(properties ?? {}),
  };
}
